import type { JSX } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useCandidateSession } from '../context/CandidateSessionContext';

export function CandidateSidebar(): JSX.Element {
  const location = useLocation();
  const { isAnonymous, shareId } = useCandidateSession();

  const dashboardPath = isAnonymous ? `/candidate/${shareId}` : '/candidate/dashboard';
  const isActive = location.pathname === dashboardPath;

  return (
    <aside className="hidden w-64 border-r bg-background md:block">
      <div className="flex h-14 items-center border-b px-4">
        <span className="text-lg font-semibold">Career Verification</span>
      </div>
      <nav className="space-y-1 p-4">
        <Link
          to={dashboardPath}
          className={cn(
            'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium',
            isActive
              ? 'bg-accent text-accent-foreground'
              : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
          )}
        >
          <LayoutDashboard className="h-4 w-4" />
          Dashboard
        </Link>
      </nav>
    </aside>
  );
}
